<template>
  <nav id="top-nav" class="flex items-center justify-between flex-wrap text-white bg-gray-700 pr-4 pl-4 border-b-4 border-pink-500">
    <div class="flex h-full items-center mr-4">
      <div class="h-full p-2">
        <img class="h-full mr-2" src="../assets/logo.png" alt="">
      </div>
      <span class="font-semibold text-xl tracking-tight">
        {{topBarMessage}}
      </span>
    </div>
    <div class="flex flex-row items-center justify-center h-full">
       <FileLoader
          class="px-2 py-1 m-2 text-sm border border-pink-400 bg-pink-500 hover:bg-pink-400 cursor-pointer text-white rounded"
          @load=barSvgLoad>
        </FileLoader>
        <div class="relative">
          <div class="inline-block select-none" @click="open = !open">
            <span class="appearance-none flex items-center inline-block text-sm px-4 py-1 border rounded hover:bg-white hover:text-gray-700 hover:border-transparent">
              <span class="mr-1">Download</span>
              <svg class="h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </span>
          </div>
          <div class="absolute right-0 mt-px" style="z-index: 50" v-show="open">
            <div class="bg-white shadow rounded border overflow-hidden">
              <a
                @click="downloadSvg($event)"
                class="w-full cursor-pointer no-underline block px-4 py-3 border-t text-black bg-white whitespace-no-wrap hover:bg-gray-700 hover:text-white">
                SVG
              </a>
              <a
                @click="downloadPng()"
                class="w-full cursor-pointer no-underline block px-4 py-3 border-t text-black bg-white whitespace-no-wrap hover:bg-gray-700 hover:text-white">
                PNG
              </a>
            </div>
          </div>
        </div>
    </div>
  </nav>
</template>

<script>
import FileLoader from "./FileLoader";

import svgPng from "save-svg-as-png";

//Thank this guy: https://stackoverflow.com/a/37387449

const ContainerElements = ["svg","g"];
const RelevantStyles = {
  "rect": ["fill", "stroke", "stroke-width"],
  "path": ["fill", "stroke", "stroke-width", "opacity", "stroke-opacity"],
  "circle": ["fill", "stroke", "stroke-width"],
  "line": ["stroke", "stroke-width"],
  "text": ["fill", "font-size", "text-anchor", "font-family"],
  "polygon": ["stroke", "fill"]
};

function readElement(ParentNode, OrigData) {
  const Children = ParentNode.childNodes;
  const OrigChildDat = OrigData.childNodes;
  for (let cd = 0; cd < Children.length; cd++) {
    const Child = Children[cd];
    const TagName = Child.tagName;
    if (ContainerElements.indexOf(TagName) != -1) {
      readElement(Child, OrigChildDat[cd])
    } else if (TagName in RelevantStyles) {
      const StyleDef = window.getComputedStyle(OrigChildDat[cd]);
      let StyleString = "";
      for (let st = 0; st < RelevantStyles[TagName].length; st++) {
        StyleString += RelevantStyles[TagName][st] + ":" + StyleDef.getPropertyValue(RelevantStyles[TagName][st]) + "; ";
      }
      Child.setAttribute("style", StyleString);
    }
    if (Child.removeAttribute) {
      Child.removeAttribute("xmlns:xlink");
    }
  }
}

function exportStyledSVG(SVGElem) {
  const oDOM = SVGElem.cloneNode(true);
  readElement(oDOM, SVGElem);
  const data = new XMLSerializer().serializeToString(oDOM);
  const svg = new Blob([data], {
    type: "image/svg+xml;charset=utf-8"
  });
  const url = URL.createObjectURL(svg);
  return url;
}

export default {
  data() {
    return {
      open: false
    };
  },
  computed: {
    topBarMessage: function() {
      let title = "SVG label editor";
      return title;
    }
  },
  methods: {
    downloadSvg(event) {
      this.open = false;
      const svgElement = document.getElementById("theSvg");
      const url = exportStyledSVG(svgElement);
      const link = event.target;
      link.setAttribute("target", "_blank");
      link.download = "cortext_export.svg";
      link.href = url;
    },
    downloadPng() {
      this.open = false;
      const svgElement = document.getElementById("theSvg");
      svgPng.saveSvgAsPng(svgElement, "cortext_export.png");
    },
    barSvgLoad(svgText) {
      this.$emit('fileLoad', svgText);
    }
  },
  components: {
    FileLoader
  }
};
</script>

<style lang="stylus">
  #top-nav
    height 48px
</style>
